(() => {
  'use strict';
  if (window.nytcHarnessUpgrade) return;
  window.nytcHarnessUpgrade = true;
  const root = window.Shopify?.routes?.root || '/';
  const GIFT = 43765867970627;
  const A_GIFT = '_nytc_explorer_gift';
  const A_SWAP = '_nytc_harness_swap';
  const money = cents => '$' + (cents / 100).toFixed(2);
  const esc = text => String(text == null ? '' : text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;');
  const isUp = item => !!(item.properties && item.properties._harness_upgrade);
  let catalog = null, host = null, busy = false, message = '', sig = '', timer;
  async function api(path, body) {
    const res = await fetch(root + path, Object.assign({ credentials: 'same-origin', cache: 'no-store' }, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : {}));
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Request failed');
    return data;
  }
  async function load() {
    if (catalog) return catalog;
    const get = async handle => { try { const r = await fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' }); return r.ok ? await r.json() : null; } catch (_) { return null; } };
    const [leather, joque, real] = await Promise.all([get('leather-harness'), get('joque-harness-upgrade-with-shilo-or-carter'), get('joque-harness')]);
    const jv = joque && joque.variants.find(v => v.available);
    catalog = {
      leatherImage: leather ? leather.featured_image : '',
      leather: leather ? leather.variants.filter(v => v.available && v.sku !== 'HARN-LTHR-TEAL').map(v => ({ id: v.id, title: v.public_title || v.title, price: v.price })) : [],
      joque: jv ? { id: jv.id, price: jv.price, image: (real && real.featured_image) || joque.featured_image || '' } : null
    };
    return catalog;
  }
  function announce() {
    sig = '';
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }
  async function settle() { try { await window.nytcExplorerGifts?.settle?.(); } catch (_) {} }
  async function reset() {
    await api('cart/update.js', { attributes: { [A_GIFT]: '', [A_SWAP]: '' } });
    await settle();
    announce();
  }
  function place() {
    if (host && host.isConnected) return host;
    const anchor = document.querySelector('[data-nytc-gift-status]');
    if (!anchor) return null;
    host = document.createElement('div');
    host.className = 'nytc-up-cart';
    host.hidden = true;
    anchor.insertAdjacentElement('afterend', host);
    host.addEventListener('click', onClick);
    sig = '';
    return host;
  }
  function choiceHtml(c) {
    if (!c.leather.length && !c.joque) return '';
    let html = "<div class='nytc-up-card'><h4>Upgrade your harness</h4><p>Swap your free Explorer for a premium harness.</p>";
    if (c.leather.length) {
      html += "<div class='nytc-up-row'>" + (c.leatherImage ? "<img src='" + esc(c.leatherImage) + "&width=120' alt=''>" : '<span></span>') + "<div><strong>Leather harness</strong><span>" + money(c.leather[0].price) + "</span><select data-up-select aria-label='Color'>" + c.leather.map(v => "<option value='" + v.id + "'>" + esc(v.title) + '</option>').join('') + "</select></div><button type='button' class='nytc-up-btn' data-up='leather'>Swap</button></div>";
    }
    if (c.joque) {
      const offerText = document.querySelector('[data-nytc-joque-offer]')?.dataset.nytcJoqueOffer || '';
      html += "<div class='nytc-up-row'>" + (c.joque.image ? "<img src='" + esc(c.joque.image) + "&width=120' alt=''>" : '<span></span>') + "<div><strong>Joque harness</strong><span>" + money(c.joque.price) + "</span>" + (offerText ? "<span>" + esc(offerText) + "</span>" : "") + "<span>Size A, fits 20-50 inch waists</span></div><button type='button' class='nytc-up-btn' data-up='joque'>Swap</button></div>";
    }
    return html + '</div>';
  }
  async function render() {
    const el = place();
    if (!el) return;
    const cart = await api('cart.js');
    const ups = cart.items.filter(isUp);
    if (!busy && cart.attributes && cart.attributes[A_SWAP] === '1' && !ups.length) { await reset(); return; }
    const gift = cart.items.find(i => i.variant_id === GIFT);
    let html = '';
    if (ups.length) html = "<div class='nytc-up-card'><h4>Harness upgraded</h4><p>Your upgrade replaces the free Explorer.</p><button type='button' class='nytc-up-back' data-up='back'>Switch back to the free Explorer</button></div>";
    else if (gift) html = choiceHtml(await load());
    const next = html + '|' + busy + '|' + message;
    if (next === sig) return;
    sig = next;
    el.hidden = !html;
    el.innerHTML = html ? html + "<p class='nytc-up-msg' role='status'>" + esc(message) + '</p>' : '';
    if (busy) el.querySelectorAll('button').forEach(b => { b.disabled = true; });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(() => { render().catch(() => {}); }, 200); }
  async function run(task, working) {
    if (busy) return;
    busy = true; message = working; sig = '';
    render().catch(() => {});
    try { await task(); message = ''; }
    catch (error) { message = error.message || 'Could not update. Please try again.'; }
    busy = false; sig = '';
    announce();
    schedule();
  }
  function swap(id) {
    return run(async () => {
      const cart = await api('cart.js');
      const gift = cart.items.find(i => i.variant_id === GIFT);
      const quantity = gift ? gift.quantity : 1;
      await api('cart/add.js', { items: [{ id, quantity, properties: { _harness_upgrade: '1' } }] });
      await api('cart/update.js', { attributes: { [A_GIFT]: '', [A_SWAP]: '1' } });
      await settle();
    }, 'Updating your cart...');
  }
  function switchBack() {
    return run(async () => {
      const cart = await api('cart.js');
      const updates = {};
      cart.items.filter(isUp).forEach(i => { updates[i.key] = 0; });
      await api('cart/update.js', { updates, attributes: { [A_GIFT]: '', [A_SWAP]: '' } });
      await settle();
    }, 'Updating your cart...');
  }
  function onClick(event) {
    const btn = event.target.closest('[data-up]');
    if (!btn || busy) return;
    const kind = btn.dataset.up;
    if (kind === 'back') { switchBack(); return; }
    const id = kind === 'leather' ? Number(host.querySelector('[data-up-select]').value) : catalog && catalog.joque && catalog.joque.id;
    if (id) swap(id);
  }
  const css = document.createElement('style');
  css.textContent = '.nytc-up-cart{margin:14px 0}.nytc-up-card{border:1px solid #d6d0e1;border-radius:10px;padding:12px;background:#faf9fd}.nytc-up-card h4{margin:0 0 2px;font-size:15px}.nytc-up-card p{margin:0 0 8px;font-size:12px;line-height:1.4}.nytc-up-row{display:grid;grid-template-columns:56px minmax(0,1fr) auto;gap:10px;align-items:center;padding:8px 0;border-top:1px solid #e7e3f0}.nytc-up-row img{width:56px;height:56px;object-fit:contain}.nytc-up-row strong{display:block;font-size:13px}.nytc-up-row span{display:block;font-size:12px}.nytc-up-row select{width:100%;min-height:36px;font-size:13px;margin:4px 0 0}.nytc-up-btn{border:0;border-radius:999px;background:#000;color:#fff;font-weight:700;font-size:13px;padding:10px 18px;cursor:pointer;min-height:40px}.nytc-up-btn[disabled]{opacity:.5}.nytc-up-msg:empty{display:none}.nytc-up-msg{font-size:12px;margin:6px 0 0}.nytc-up-back{background:none;border:0;text-decoration:underline;padding:6px 0;cursor:pointer;font-size:12px}';
  document.head.appendChild(css);
  ['cart:updated', 'cart:build', 'cart:open', 'page:loaded', 'ajaxProduct:added'].forEach(name => document.addEventListener(name, schedule));
  const drawer = document.getElementById('CartDrawer');
  if (drawer) new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('pageshow', schedule);
  schedule();
})();


